module.exports = __webpack_public_path__ + "img/ic_preview.0b6d8c26.png";